import { Calendar } from "primereact/calendar";
import React from "react";
import { strTimeAsNativeDate } from "./Time";
import { T } from "services/lang/LanguageService";

export type Item = {
  id: string;
  value: string;
};

interface TimeValueEditorProps {
  data: Item;
  onCommit: (v: string) => void;
}

const TimeValueEditor = ({ data, onCommit }: TimeValueEditorProps) => {
  const dateValue = data.value ? strTimeAsNativeDate(data.value) : null;

  const handleChangeTime = (e: any) => {
    const d = e.value as Date | null;
    if (!d) return;

    const newValue = `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;

    if (newValue !== data.value) {
      onCommit(newValue);
    }
  };

  return (
    <div onClick={e => e.stopPropagation()}>
      <Calendar
        value={dateValue}
        onChange={handleChangeTime}
        placeholder={T("placeholder.time-not-set")}
        className="w-full"
        timeOnly
        stepMinute={1}
      />
    </div>
  );
};

export default TimeValueEditor;
